import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TimePickerService {
  private dateTime = new Subject<any>();
  private currentFormControl: any;
  private isTimeMax;

  setIsTimeMax(value) {
    this.isTimeMax = value;
  }

  getIsTimeMax() {
    return this.isTimeMax;
  }

  setSelectedTimeDate(value: any) {
      this.dateTime.next(value);
  }

  getSelectedTimeDate(): Observable<any> {
    return this.dateTime.asObservable();
  }

  setFormControlName(formControlName) {
    this.currentFormControl = formControlName;
  }

  getFormControlName() {
    return this.currentFormControl;
  }

}
